import { requestApi } from './helper';

export const SAVE_TASKS = 'SAVE_TASKS';
export const SAVE_TASKS_ALL = 'SAVE_TASKS_ALL';
export const SAVE_GROUPED_TASKS = 'SAVE_GROUPED_TASKS';
export const SAVE_GROUPED_TASKS_ALL = 'SAVE_GROUPED_TASKS_ALL';
export const SAVE_ISSUES = 'SAVE_ISSUES';
export const SAVE_ISSUES_ALL = 'SAVE_ISSUES_ALL';
export const SAVE_DATAPICK_TASKS = 'SAVE_DATAPICK_TASKS';
export const SAVE_DATAPICK_TASKS_ALL = 'SAVE_DATAPICK_TASKS_ALL';
export const SAVE_INSTALLATION_DOCUMENT_TASKS = 'SAVE_INSTALLATION_DOCUMENT_TASKS';
export const SAVE_INSTALLATION_DOCUMENT_TASKS_ALL = 'SAVE_INSTALLATION_DOCUMENT_TASKS_ALL';

export const saveTasks = (tasks) => ({
  type: SAVE_TASKS,
  tasks,
});
export const saveTasksAll = (tasksAll) => ({
  type: SAVE_TASKS_ALL,
  tasksAll,
});
export const saveIssues = (issues) => ({
  type: SAVE_ISSUES,
  issues,
});
export const saveIssuesAll = (issuesAll) => ({
  type: SAVE_ISSUES_ALL,
  issuesAll,
});
export const saveGroupedTasks = (groupedTasks) => ({
  type: SAVE_GROUPED_TASKS,
  groupedTasks,
});
export const saveGroupedTasksAll = (groupedTasksAll) => ({
  type: SAVE_GROUPED_TASKS_ALL,
  groupedTasksAll,
});
export const saveDatapickTasks = (datapickTasks) => ({
  type: SAVE_DATAPICK_TASKS,
  datapickTasks,
});
export const saveDatapickTasksAll = (datapickTasksAll) => ({
  type: SAVE_DATAPICK_TASKS_ALL,
  datapickTasksAll,
});
export const saveInstallationDocumentTasks = (installationDocumentTasks) => ({
  type: SAVE_INSTALLATION_DOCUMENT_TASKS,
  installationDocumentTasks,
});
export const saveInstallationDocumentTasksAll = (installationDocumentTasksAll) => ({
  type: SAVE_INSTALLATION_DOCUMENT_TASKS_ALL,
  installationDocumentTasksAll,
});

export const requestTasks = (startDate, endDate, page, jsonObj, errorCallback, successCallback) => {
  let path = '/tasks/search';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  path = `${path}?p=${page}`;
  if (startDate) {
    path = `${path}&startDate=${startDate}`;
  }
  if (endDate) {
    path = `${path}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveTasks, errorCallback, successCallback);
};

export const requestTasksAll = (startDate, endDate, jsonObj, errorCallback, successCallback) => {
  let path = '/tasks/searchall';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  let prefix = '?';
  if (startDate) {
    path = `${path}${prefix}startDate=${startDate}`;
    prefix = '&';
  }
  if (endDate) {
    path = `${path}${prefix}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveTasksAll, errorCallback, successCallback);
};

export const requestIssues = (startDate, endDate, page, jsonObj, errorCallback, successCallback) => {
  let path = '/issues/search';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  path = `${path}?p=${page}`;
  if (startDate) {
    path = `${path}&startDate=${startDate}`;
  }
  if (endDate) {
    path = `${path}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveIssues, errorCallback, successCallback);
};

export const requestIssuesAll = (startDate, endDate, jsonObj, errorCallback, successCallback) => {
  let path = '/issues/searchall';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  let prefix = '?';
  if (startDate) {
    path = `${path}${prefix}startDate=${startDate}`;
    prefix = '&';
  }
  if (endDate) {
    path = `${path}${prefix}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveIssuesAll, errorCallback, successCallback);
};

export const requestGroupedTasks = (startDate, endDate, page, jsonObj, errorCallback, successCallback) => {
  let path = '/tasks/grouped/search';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  path = `${path}?p=${page}`;
  if (startDate) {
    path = `${path}&startDate=${startDate}`;
  }
  if (endDate) {
    path = `${path}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveGroupedTasks, errorCallback, successCallback);
};

export const requestGroupedTasksAll = (startDate, endDate, jsonObj, errorCallback, successCallback) => {
  let path = '/tasks/grouped/searchall';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  let prefix = '?';
  if (startDate) {
    path = `${path}${prefix}startDate=${startDate}`;
    prefix = '&';
  }
  if (endDate) {
    path = `${path}${prefix}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveGroupedTasksAll, errorCallback, successCallback);
};

export const requestDatapickTasks = (startDate, endDate, page, jsonObj, errorCallback, successCallback) => {
  let path = '/datapick/search';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  path = `${path}?p=${page}`;
  if (startDate) {
    path = `${path}&startDate=${startDate}`;
  }
  if (endDate) {
    path = `${path}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveDatapickTasks, errorCallback, successCallback);
};

export const requestDatapickTasksAll = (startDate, endDate, jsonObj, errorCallback, successCallback) => {
  let path = '/datapick/searchall';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  let prefix = '?';
  if (startDate) {
    path = `${path}${prefix}startDate=${startDate}`;
    prefix = '&';
  }
  if (endDate) {
    path = `${path}${prefix}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveDatapickTasksAll, errorCallback, successCallback);
};

export const requestInstallationDocumentTasks = (startDate, endDate, page, jsonObj, errorCallback, successCallback) => {
  let path = '/installationdocument/report/search';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  path = `${path}?p=${page}`;
  if (startDate) {
    path = `${path}&startDate=${startDate}`;
  }
  if (endDate) {
    path = `${path}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveInstallationDocumentTasks, errorCallback, successCallback);
};

export const requestInstallationDocumentTasksAll = (startDate, endDate, jsonObj, errorCallback, successCallback) => {
  let path = '/installationdocument/report/searchall';

  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };

  let prefix = '?';
  if (startDate) {
    path = `${path}${prefix}startDate=${startDate}`;
    prefix = '&';
  }
  if (endDate) {
    path = `${path}${prefix}&endDate=${endDate}`;
  }

  return requestApi(path, requestProperties, saveInstallationDocumentTasksAll, errorCallback, successCallback);
};



// WEBPACK FOOTER //
// ./src/actions/servicereport.js